// extracted by mini-css-extract-plugin
module.exports = {"SocialContainer":"social_SocialContainer__2NxLb","SocialLink":"social_SocialLink__ymI7f","MobileSocialIcon":"social_MobileSocialIcon__1ibpA"};